<template>
    <div id="suivi-de-connexion">

        <b-modal hide-footer ref="my-modal" title="Détail">

            <b-card>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Nom complet">
                            <b-form-input size="sm" v-model="fullName" placeholder="Nom d'complet" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Email">
                            <b-form-input size="sm" v-model="email" placeholder="Email" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Nom d'utilisateur">
                            <b-form-input :disabled="isModif" size="sm" v-model="username"
                                placeholder="Nom d'utilisateur" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Mot de passe">
                            <b-form-input size="sm" type="password" v-model="password" placeholder="Mot de passe" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" v-for="(item, index) in permissions" :key="index">
                        <b-form-checkbox v-model="item.selected" class="custom-control-primary" plain>
                            {{ item.name }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>

            <b-row class="text-right">

                <b-col cols="12" md="12">
                    <b-button @click="save" variant="relief-success"
                        :disabled="username.trim() == '' || password.trim() == ''">
                        Sauvegarder
                    </b-button>
                </b-col>

            </b-row>

        </b-modal>


        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :agGrid="agGrid" pageTitle="Liste des utilisateurs" @refresh="loadData" :add="true"
                    @plusClicked="showModal" @cellDoubleClicked="cellDoubleClicked" />
            </b-card>
        </b-overlay>

    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            isModif: false,
            fullName: "",
            email: "",
            username: "",
            password: "",
            permissions: [{ "name": "Dashboard", id: 13, selected: false },
            { "name": "Liste des clients", id: 14, selected: false },
            { "name": "Liste des commandes", id: 16, selected: false },
            { "name": "Suivi de connexion", id: 17, selected: false },
            { "name": "Liste des articles", id: 6, selected: false },
            { "name": "Détail article", id: 7, selected: false },
            { "name": "Devenir client", id: 40, selected: false }],
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Nom Complet",
                        field: "fullName",
                    },
                    {
                        headerName: "Email",
                        field: "email",
                    },
                    {
                        headerName: "Nom d'utilisateur",
                        field: "username",
                    },
                    {
                        headerName: "Crée Le",
                        field: "createdAt",
                    },
                ],
                rows: []
            },
            showLoading: true,
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        save() {
            console.log("data saved ! ");
            this.$refs["my-modal"].hide();
            this.showLoading = true;
            let modeatorDto = {
                username: this.username,
                password: this.password,
                fullName: this.fullName,
                email: this.email,
                permissions: this.permissions.filter(item => item.selected).map(item => item.id)
            };
            console.log(modeatorDto);
            this.$http.post("modeator", modeatorDto).then(response => {
                console.log(response);
                this.loadData();
            }).catch(error => {
                console.log(error);
                this.showLoading = false;
                this.$swal({
                    title: "Erreur s'est produite lors de la récupération des données",
                    text: error.data,
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            });
        },
        showModal() {
            this.permissions = [{ "name": "Dashboard", id: 13, selected: false },
            { "name": "Liste des clients", id: 14, selected: false },
            { "name": "Liste des commandes", id: 16, selected: false },
            { "name": "Suivi de connexion", id: 17, selected: false },
            { "name": "Liste des articles", id: 6, selected: false },
            { "name": "Détail article", id: 7, selected: false },
            { "name": "Devenir client", id: 40, selected: false }];
            this.isModif = false;
            this.fullName = "";
            this.email = "";
            this.username = "";
            this.password = "";
            this.$refs['my-modal'].show();
        },
        cellDoubleClicked(data) {
            this.permissions = [{ "name": "Dashboard", id: 13, selected: data.data.permissions.findIndex(item => item.id == 13) != -1 },
            { "name": "Liste des clients", id: 14, selected: data.data.permissions.findIndex(item => item.id == 14) != -1 },
            { "name": "Liste des commandes", id: 16, selected: data.data.permissions.findIndex(item => item.id == 16) != -1 },
            { "name": "Suivi de connexion", id: 17, selected: data.data.permissions.findIndex(item => item.id == 17) != -1 },
            { "name": "Liste des articles", id: 6, selected: data.data.permissions.findIndex(item => item.id == 6) != -1 },
            { "name": "Détail article", id: 7, selected: data.data.permissions.findIndex(item => item.id == 7) != -1 },
            { "name": "Devenir client", id: 40, selected: data.data.permissions.findIndex(item => item.id == 40) != -1 }];
            this.isModif = true;
            this.fullName = data.data.fullName;
            this.email = data.data.email;
            this.username = data.data.username;
            this.password = "0000000000";
            this.$refs['my-modal'].show();
        },
        loadData() {
            this.showLoading = true;
            this.$http.get("/modeator")
                .then(response => {
                    console.log(response);
                    this.agGrid.rows = response.data.reverse();
                    this.showLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.showLoading = false;
                    this.$swal({
                        title: "Erreur s'est produite lors de la récupération des données",
                        text: error.data,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                });
        },
    }
}
</script>

<style lang="scss"></style>
